export const getAmazonS3Url = (s3Bucket: string, s3Key: string) => {
  return `https://${s3Bucket}.s3.amazonaws.com/${s3Key}`;
};